export default "__VITE_ASSET__c4511e18__"